import { localAESStorage } from "@/util/storage";
import { isNull } from "__barrel_optimize__?names=isNull!=!lodash-es";
export function getUrlParam(_paramName, _url) {
  const reg = new RegExp("(^|&)".concat(_paramName, "=([^&]*)(&|$)"), "i");
  let url = _url || window.location.href;
  if (url && url.replace) {
    url = url.replace("#/", "").toString();
    const r = ((url ? url.split("?")[1] : encodeURI(window.location.search).substr(1)) || "").match(reg);
    if (!isNull(r)) return unescape(r[2]);
  }
  return null;
}
export function deleteSearchKey(searchKey) {
  if (!getUrlParam(searchKey)) return;
  const search = location.search;
  const afterFilterSearch = search.split("?")[1].split("&").filter(item => {
    return item.indexOf(searchKey) == -1;
  }).join("&");
  const searchParams = afterFilterSearch ? "?" + afterFilterSearch : afterFilterSearch;
  history.replaceState({}, "", "".concat(location.pathname + searchParams));
}
/**
 * 清理 invitation 数据
 */
export function clearInvitationData() {
  deleteSearchKey("invitation");
  localAESStorage.removeItem("inviteCodeMap");
}